<modal-hoc
    [modalTitle]="modalTitle"
    [submitButton]="true"
    [cancelButton]="true"
    (modalCancel)="onModalCancel($event)"
    (modalSubmit)="onModalSubmit($event)"
    [submitText]="submitText"
    [modalTheme]="export?.paused === '1' && !bigCommerceSelfService.showRestrictedUI() ? 'warning' : 'secondary'">
    @if (skuLimitAlert) {
        <fdx-surface-sku-limit-alert
            [tier]="skuLimitAlert.tier"
            [feature]="skuLimitAlert.feature"
            [dismissible]="false"
            [separateTitle]="true"
            [inlineLinks]="true"
            [canRememberDismissed]="false"
            [plansUrl]="bigCommerceLinkService.planUrl$ | async"
            [productsUrl]="productsUrl"
        />
    }
    @if (bigCommerceSelfService.showRestrictedUI()) {
        <div class="vstack">
            <span class="mb-4">This will replace your current product feed. Pause other apps that update this channel to avoid conflicts.</span>

            @if (!isWebhookExport) {
                <div class="fw-bold">How updates work</div>
                <ul class="mb-4">
                    <li>Feedonomics updates the feed file based on your sync frequency</li>
                    <li>The channel pulls the latest file on its own schedule or when triggered manually</li>
                </ul>
            }

            <small>
                Visit the <a [href]="linkService.bcSelfServiceFAQ" rel="noopener" referrerpolicy="no-referrer" target="_blank" class="btn-link">Help Center <fa-icon [icon]="externalLinkIcon"></fa-icon></a> to learn more.
            </small>
        </div>
    } @else {
        <div class="mb-3">
            @if (export?.paused === '1') {
                This export is paused. Pushing this export may update your data in an unexpected way. Do you still want to export?
            } @else if (export?.paused === '0') {
                Please confirm this information is correct before proceeding.
            }
        </div>

        <table class="table table-rounded">
            <tbody>
            <tr>
                <th>Destination</th>
                <td>
                    @if (destinationUrl) {
                        {{destinationUrl}}
                    } @else {
                        <div class="fst-italic p-0">None</div>
                    }
                </td>
            </tr>
            <tr>
                <th>Export name</th>
                <td>{{export?.name}}</td>
            </tr>
            @if (export?.paused !== '1') {
                <tr>
                    <th>Next scheduled run</th>
                    <td>
                        @if (export?.cron) {
                            {{timeToNextExport}} at
                            <fdx-date-time-localized
                                [dateTime]="nextScheduledExport"
                                [timezone]="export.cron_timezone"
                                class="px-0">
                            </fdx-date-time-localized>
                        } @else {
                            <div class="fst-italic p-0">Unscheduled</div>
                        }
                    </td>
                </tr>
            }
            </tbody>
        </table>
    }
</modal-hoc>
